import { AppService } from './services/app.service';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { MessagesService } from './services/messages.service';
import { UploadComponent } from './upload/upload.component';
import { DadosDoColaborador } from './models/dados-colaborador';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title: string = 'Indicação Premiada';
  form: FormGroup;
  showTelefone = true;
  v_filial: string;

  @ViewChild(UploadComponent) uploadComponent!: UploadComponent;

  constructor(
    private fb: FormBuilder,
    private service: AppService<DadosDoColaborador>,
    private message: MessagesService,
    private element: ElementRef,
  ) {
    this.form = this.fb.group({
      matricula: [
        '',
        Validators.compose([
          Validators.minLength(6),
          Validators.maxLength(6),
          Validators.required,
        ]),
      ],
      nome: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(100)]),
      ],
      telefone: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(11),
        ]),
      ],
      telefoneDoCandidato: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(11),
        ]),
      ],
      nomeDoCandidato: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(100)]),
      ],
      arquivo: [null, Validators.required],
    });
  }

  onFileReceived(file: File | null): void {
    this.form.patchValue({
      arquivo: file,
    });

    this.form.get('arquivo')?.markAsTouched();
  }

  moveCursorToEnd(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Timeout necessário para o Android concluir o focus
    setTimeout(() => {
      const length = input.value.length;
      input.setSelectionRange(length, length);
    }, 0);
  }

  Get(evento: any) {
    let matricula: string = evento.target.value;

    this.v_filial = '';

    if (matricula.length === 6) {
      this.service
        .Get(`?matricula=${matricula}`)
        .pipe(first())
        .subscribe((x) => {
          if (x.nome !== '') {
            this.form.patchValue({
              nome: x.nome,
            });

            this.v_filial = x.filial;
            this.Focus('#txtTelefone');
          }
        });
    } else {
      if (matricula.length === 5) {
        this.form.patchValue({
          nome: '',
          telefone: '',
          telefoneDoCandidato: '',
          nomeDoCandidato: '',
        });
      }
    }
  }

  // Post() {
  //   var dados = new Dados();
  //   dados = this.form.value;
  //   this.service.Post(dados).pipe(first()).subscribe(x => {
  //     //this.message.onMessage('Indicação realizada com sucesso!', 200);
  //     this.message.Message(this.MessageOk(dados.nome, dados.nomeDoCandidato), 200);
  //     this.ResetForm();
  //     this.Focus('#txtMatricula');
  //   });
  // }

  Post() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const arquivo = this.form.get('arquivo')?.value as File | null;

    if (!arquivo) {
      this.message.Message('Selecione um arquivo!', 400);
      return;
    }

    const formData = new FormData();

    formData.append('Filial', this.v_filial);
    formData.append('Matricula', this.form.value.matricula);
    formData.append('Nome', this.form.value.nome);
    formData.append('Telefone', this.form.value.telefone);
    formData.append('TelefoneDoCandidato', this.form.value.telefoneDoCandidato);
    formData.append('NomeDoCandidato', this.form.value.nomeDoCandidato);

    formData.append('ArquivoCurriculo', arquivo);

    this.service
      .Post(formData)
      .pipe(first())
      .subscribe({
        next: () => {
          this.message.Message(
            this.MessageOk(
              this.form.value.nome,
              this.form.value.nomeDoCandidato,
            ),
            200,
          );
          this.ResetForm();
          this.Focus('#txtMatricula');
        },
        error: () => {
          this.message.Message(
            'Erro ao realizar indicação. Verifique os dados informados!',
            500,
          );
        },
      });
  }

  // ResetForm() {
  //   this.form.reset();

  //   // força limpeza do componente de upload
  //   if (this.uploadComponent) {
  //     this.uploadComponent.clear();
  //   }
  // }

  ResetForm() {
    this.form.reset({
      matricula: '',
      nome: '',
      telefone: '',
      telefoneDoCandidato: '',
      nomeDoCandidato: '',
    });

    // força limpeza do componente de upload
    if (this.uploadComponent) {
      this.uploadComponent.clear();
    }

    // Destrói o input (mata o ngx-mask)
    this.showTelefone = false;

    // Recria o input limpo
    setTimeout(() => {
      this.showTelefone = true;
    });
  }

  Focus(input: string) {
    const element = this.element.nativeElement.querySelector(input);
    element.focus();
  }

  MessageOk(nome: string, nomeDoCandidato: string) {
    let message: string = '';

    message =
      'Olá ' +
      '<strong class="upper">' +
      nome +
      '</strong>' +
      ',<br/>' +
      'A equipe de Recrutamento e Seleção da Rede Confiança de Supermercados agradece pelo seu engajamento e por acreditar nos valores da empresa. ' +
      'Sua indicação do(a) candidato(a) ' +
      '<strong class="upper">' +
      nomeDoCandidato +
      '</strong>' +
      ' foi recebida com sucesso e já está participando do Programa Indicação Premiada. ' +
      'Assim que surgirem oportunidades alinhadas ao perfil do(a) candidato(a), entraremos em contato.';

    return message;
  }
}
